import styled, { createGlobalStyle } from 'styled-components';

export const LandingRoot = styled.div`
  background: #ffffff;
`;

/**
 * The app's `body { margin: 0 }` reset lives in normalize.css, which is
 * interpolated into the global `createGlobalStyle` as an imported CSS string.
 * That import only resolves to real CSS in the client bundle, so it's absent
 * from the server-rendered HTML — without JS the browser's default
 * `body { margin: 8px }` shows as a side gutter until hydration applies it.
 *
 * This page-scoped reset is written inline (so styled-components includes it in
 * the SSR output) and is only mounted while the SG landing is rendered, keeping
 * the page full-bleed without JS without touching global app styles.
 */
export const SGGlobalStyle = createGlobalStyle`
  body {
    margin: 0;
  }
`;
